module.exports = __webpack_public_path__ + "static/media/pic-ht9.f1b98bdd.jpg";